<template>
    <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
        <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-form-item label="收款单位" prop="corporation">
                    <el-input v-model="form.model.corporation" :maxlength="60" :disabled="!editable" size="small"/>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-form-item label="开户银行" prop="bank">
                    <el-input v-model="form.model.bank" :maxlength="60" :disabled="!editable" size="small"/>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-form-item label="账号" prop="account">
                    <el-input v-model="form.model.account" :maxlength="60" :disabled="!editable" size="small"/>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-form-item label="联系人" prop="contact">
                    <el-input v-model="form.model.contact" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <el-form-item label="电话" prop="phone">
                    <el-input v-model="form.model.phone" :maxlength="60" placeholder="限60字符" :disabled="!editable" size="small">
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
    import BillingServer from "@/api/billing";

    export default {
        name: "receipt-cfg-form",
        data() {
            return {
                form: {
                    model: {
                        corporation: null,
                        bank: null,
                        account: null,
                        contact: null,
                        phone: null,
                    },
                },
            }
        },
        computed: {
            editable() {
                return true;
            },
            formRules() {
                return {
                    corporation: [
                        { required: true, message: '请填写收款单位', trigger: 'blur' },
                    ],
                    bank: [
                        { required: true, message: '请填写开户银行', trigger: 'blur' },
                    ],
                    account: [
                        { required: true, message: '请填写账号', trigger: 'blur' },
                    ],
                    contact: [
                        { required: true, message: '请填写联系人', trigger: 'blur' },
                    ],
                    phone: [
                        { required: true, message: '请填写电话', trigger: 'blur' },
                    ],
                };
            },
        },
        methods: {
            getInitModel() {
                return {
                    corporation: null,
                    bank: null,
                    account: null,
                    contact: null,
                    phone: null,
                };
            },
            toAdd() {
                this.form.model = this.getInitModel();
            },
            async saveAdd() {
                let promise;
                try {
                    let validated = await this.$refs.form.validate();
                    if (validated) {
                        let model = this.form.model;
                        let response = await BillingServer.receiptConfig.add(model);
                        if (response.data.success) {
                            promise = Promise.resolve(response.data.data);
                            this.emitSaveSuccess(response.data.data);
                        } else {
                            promise = Promise.reject(response);
                            this.emitSaveFail(response);
                        }
                    } else {
                        promise = Promise.reject({});
                    }
                } catch (error) {
                    promise = Promise.reject(error);
                    this.emitSaveFail(error);
                }
                return promise;
            },
            emitSaveSuccess(data) {
                this.$emit('save-success', data);
            },
            emitSaveFail(error) {
                this.$emit('save-fail', error);
            }
        },
    }
</script>

<style scoped>

</style>